var _a;
import { SocialNetwork } from './SocialIcon';
var socialNetworkToKeyMap = (_a = {},
    _a[SocialNetwork.BEHANCE] = 'social.behance',
    _a[SocialNetwork.DRIBBLE] = 'social.dribbble',
    _a[SocialNetwork.ETSY] = 'social.etsy',
    _a[SocialNetwork.FACEBOOK] = 'social.facebook',
    _a[SocialNetwork.FLICKR] = 'social.flickr',
    _a[SocialNetwork.INSTAGRAM] = 'social.instagram',
    _a[SocialNetwork.LINKEDIN] = 'social.linkedin',
    _a[SocialNetwork.PATREON] = 'social.patreon',
    _a[SocialNetwork.PINTEREST] = 'social.pinterest',
    _a[SocialNetwork.TUMBLR] = 'social.tumblr',
    _a[SocialNetwork.TWITCH] = 'social.twitch',
    _a[SocialNetwork.TWITTER] = 'social.twitter',
    _a[SocialNetwork.VIMEO] = 'social.vimeo',
    _a[SocialNetwork.YOUTUBE] = 'social.youtube',
    _a);
export function networkToTranslationKey(network) {
    return socialNetworkToKeyMap[network];
}
//# sourceMappingURL=utils.js.map